import { Environment, Metadata } from '@workspaces/types'
import sharedPlanService from '@/services/sharedPlan.service'

interface SharedPlanInfoManagerInterface {
  isPasswordRequired(): boolean
  isActive(): boolean
  isPlanNotFound(): boolean
  isExpired(): boolean
  setPassword(password: string): void
  getPassword(): string | undefined
  init(
    meta: Metadata.AppMetadata,
    environment: Environment.EnvironmentResolver,
    sharedPlanId: string,
  ): Promise<void>
}

// prettier-ignore
export default class SharedPlanInfoManager implements SharedPlanInfoManagerInterface {
  private static instance: SharedPlanInfoManagerInterface
  private password: string | undefined
  private passwordRequired: boolean
  private alreadyInit: boolean
  private isSharePlanActive: boolean
  private isBasePlanNotFound: boolean
  private isSharePlanExpired: boolean
  private constructor() {
    this.alreadyInit = false
    this.password = undefined
    this.passwordRequired = true
    this.isSharePlanActive = false
    this.isBasePlanNotFound = true
    this.isSharePlanExpired = true
  }

  public async init(
    meta: Metadata.AppMetadata,
    environment: Environment.EnvironmentResolver,
    sharedPlanId: string,
  ): Promise<void> {
    if (this.alreadyInit) {
      throw new Error(
        '🔴 SharedPlanInfoManager --> Already initialized. Cannot be intialized more than once',
      )
    }
    const sharedPlanState = await sharedPlanService.getSharedPlanInfo(
      meta,
      environment,
      sharedPlanId,
    )
    this.passwordRequired = sharedPlanState.isPasswordRequired
    this.isSharePlanActive = sharedPlanState.isActive
    this.isBasePlanNotFound = sharedPlanState.isPlanNotFound
    this.isSharePlanExpired = sharedPlanState.isExpired
  }

  public static getInstance(): SharedPlanInfoManagerInterface {
    if (!SharedPlanInfoManager.instance) {
      SharedPlanInfoManager.instance = new SharedPlanInfoManager()
    }
    return SharedPlanInfoManager.instance
  }

  public isPasswordRequired(): boolean {
    return this.passwordRequired
  }

  public isActive(): boolean {
    return this.isSharePlanActive
  }

  public isPlanNotFound(): boolean {
    return this.isBasePlanNotFound
  }

  public isExpired(): boolean {
    return this.isSharePlanExpired
  }

  public getPassword(): string | undefined {
    const isPasswordRequired = this.isPasswordRequired()

    if (!isPasswordRequired) {
      return undefined
    }

    if (!this.password) {
      throw new Error(
        '🔴 SharedPlanInfoManager --> Trying to retreive a password but NO password has been provided',
      )
    }

    return this.password
  }

  public setPassword(password: string): void {
    this.password = password
  }
}
